export const DiscordIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_191_27216)">
      <circle
        cx="20.1111"
        cy="20"
        r="20"
        fill="#2A2648"
      />
      <path
        d="M28.4405 12.3296C26.8644 11.6036 25.1997 11.0893 23.4895 10.8C23.2723 11.1802 23.0274 11.69 22.8556 12.1024C21.0368 11.8308 19.1881 11.8308 17.3682 12.1024C17.1742 11.6579 16.957 11.2234 16.7176 10.8C15.0052 11.0893 13.3382 11.6058 11.7622 12.3362C8.63776 16.9946 7.78988 21.5421 8.21216 26.0198C10.0465 27.3831 12.1013 28.4194 14.287 29.0855C14.7791 28.4194 15.2136 27.7133 15.5893 26.9741C14.8788 26.7092 14.1939 26.3811 13.5411 25.9954C13.7118 25.8669 13.8769 25.7372 14.0354 25.6075C17.8813 27.4263 22.3402 27.4263 26.185 25.6075C26.348 25.7416 26.5164 25.8724 26.686 25.9976C26.0321 26.3856 25.3449 26.7147 24.6334 26.9807C25.008 27.7178 25.4424 28.4227 25.9357 29.0877C28.1224 28.4238 30.1784 27.3864 32.0105 26.022C32.5048 20.8305 31.1559 16.324 28.4394 12.3296H28.4405ZM16.1235 23.2689C14.9387 23.2689 13.9667 22.1838 13.9667 20.8516C13.9667 19.5194 14.9165 18.4254 16.1235 18.4254C17.3305 18.4254 18.2936 19.5105 18.2826 20.845C18.2715 22.1794 17.3305 23.2689 16.1235 23.2689ZM24.0969 23.2689C22.9121 23.2689 21.9401 22.1838 21.9401 20.8516C21.9401 19.5194 22.8899 18.4254 24.0969 18.4254C25.3039 18.4254 26.267 19.5105 26.2537 20.845C26.2404 22.1794 25.3039 23.2689 24.0969 23.2689Z"
        fill="#704EFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_191_27216">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.111084)"
        />
      </clipPath>
    </defs>
  </svg>
);
